import axios from 'axios'

// Interceptor for handling response errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear()
      sessionStorage.clear()
    }
    return Promise.reject(error);
  }
);

const post = ({payload, jwt}) => {
  const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
        'x-auth-token': jwt
    }
  }
  return axios.post('/api/magic-link/project', payload, config)
}
const auth = (hash_id) => {
  const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS'
    }
  }
  return axios.post('/api/auth/magic-link', {hash_id}, config)
}
const sendLink = (payload) => {
  const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin' : '*',
        'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS'
    }
  }
  return axios.post('/api/magic-link/login', payload, config)
}
const magicLinkAPI = { post, auth, sendLink }
export default magicLinkAPI